import { Grid, OutlinedInput, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { get as _get } from 'lodash';
import { useState } from 'react';

export default function PhoneInput(props: any) {
  const [phoneNumber, setPhoneNumber] = useState(formatPhone(_get(props, 'defaultValue', '')));
  const [hideSubCase] = useState(_get(props, 'hideSubCase', true));
  const [isPhoneValid, setIsPhoneValid] = useState(_get(props, 'defaultValue', '').length >= 10 || !props.isRequired);
  const theme = useTheme();
  props.phoneValid(isPhoneValid);

  function phoneChange(e: any) {
    const p = formatPhone(_get(e, 'target.value', ''));
    setPhoneNumber(p);
    const rawPhone = p.replace(/[^\d]/g, '');
    props.phoneValueUpdate(rawPhone);

    // Only set validation while typing once we finish typing full number
    if (rawPhone.length === 10) {
      setIsPhoneValid(true);
      props.phoneValid(true);
    } else if (!props.isRequired && !rawPhone) {
      setIsPhoneValid(true);
      props.phoneValid(true);
    }
  }

  function validateChange(e: any) {
    const p = formatPhone(_get(e, 'target.value', ''));
    const rawPhone = p.replace(/[^\d]/g, '');
    if (!props.isRequired && !rawPhone) {
      setIsPhoneValid(true);
      props.phoneValid(true);
    } else {
      setIsPhoneValid(rawPhone.length === 10);
      props.phoneValid(rawPhone.length === 10);
    }
  }

  function formatPhone(p: string) {
    const phone = p.replace(/[^\d]/g, '');
    const pLength = phone.length;
    if (pLength < 4) {
      return phone;
    } else if (pLength < 7) {
      return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
    } else {
      return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
    }
  }

  return (
    <Grid container>
      {!hideSubCase && (
        <Grid item xs={12}>
          <Typography sx={{ ...theme.custom.styles.formLabelStyle, marginBottom: '5px' }}>Phone Number</Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <OutlinedInput
          sx={{ width: props.width || '100%', marginTop: '0px' }}
          margin="dense"
          type="tel"
          size="small"
          onChange={phoneChange}
          onBlur={validateChange}
          value={phoneNumber}
          inputProps={{
            maxLength: 14,
          }}
        />
      </Grid>
      {!isPhoneValid && (
        <Grid
          sx={{
            marginTop: '0px',
            marginRight: props.margin || '0%',
            display: 'flex',
          }}
          item
          xs={12}
        >
          <Typography sx={theme.custom.styles.errorSubcaseFont}>
            {props.isRequired ? 'Required' : 'Enter a Valid Phone Number'}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
